export default __webpack_public_path__ + "static/media/user_icon.160a90ce.png";